/*
 * @Author: 邓宇芩 707208431@qq.com
 * @Date: 2025-12-08 14:04:57
 * @LastEditors: 邓宇芩 707208431@qq.com
 * @LastEditTime: 2025-12-17 13:51:29
 * @FilePath: \scanqrcode\src\locales\en.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  languageLabel: "Language",
  languageOptions: {
    en: "English",
    zh_CN: "Simplified Chinese",
    zh_TW: "Traditional Chinese",
  },
  scannerNameLabel: "Name of QR Code Scanner",
  scannerNamePlaceholder: "Name of QR Code Scanner",
  passwordLabel: "Password",
  passwordPlaceholder: "Please enter your password...",
  loginButton: "Log in",
  enterButton: "Enter",
  toastFillFields: "Please fill in all fields",
  toastLoginFailed: "Login failed",
  indexEventTitle: "2025 HowZ Concert in Taipei",
  indexStatsTotal: "Total Records",
  indexStatsCheckedIn: "Claimed",
  indexStatsPending: "Unclaimed",
  indexSearchPlaceholder: "Search...",
  indexStatusFilters: {
    all: "All",
    claimed: "Claimed",
    unclaimed: "Unclaimed",
  },
  indexTableHeaders: {
    name: "Name",
    email: "Email",
    checkInTime: "Claimed Time",
    status: "Status",
  },
  indexEmpty: "No results found.",
  indexPaginationPrev: "Prev",
  indexPaginationNext: "Next",
  indexPaginationPage: "Page",
  indexPaginationOf: "of",
  indexScanButton: "Scan QR Code",
  indexStatusLabels: {
    claimed: "claimed",
    unclaimed: "unclaimed",
  },
  indexDetailTitle: "Detail",
  indexDetailName: "Name:",
  indexDetailEmail: "Email:",
  indexDetailCheckInTime: "Claimed Time:",
  indexDetailStatus: "Status:",
  indexDetailClose: "Close",
  readerDetailItemHolder: "Item Holder:",
  readerDetailItemName: "Item Name:",
  readerDetailOrderItems: "Items:",
  readerDetailVariantDetails: "Variant:",
  readerDetailEmailAddress: "Email Address:",
  readerDetailCheckInTime: "Claimed Time:",
  readerModalClose: "Close",
};
